/**
 * Constantes para features de planos
 * Define quais features estão disponíveis em cada plano
 */
export const FEATURES = {
  STATISTICS: 'statistics',
  ADVANCED_REPORTS: 'advanced_reports',
  UNLIMITED_USERS: 'unlimited_users',
  CUSTOM_BRANDING: 'custom_branding',
  ADVANCED_AUTOMATION: 'advanced_automation',
  DATA_EXPORT: 'data_export',
  PRIORITY_SUPPORT: 'priority_support',
  FINANCIAL_MANAGEMENT: 'financial_management',
  MARKETING_TOOLS: 'marketing_tools',
  PATIENT_PORTAL: 'patient_portal',
  WAITING_LIST: 'waiting_list',
  WALLET_MANAGEMENT: 'wallet_management',
  WHATSAPP_COMMUNICATION: 'whatsapp_communication',
};

/**
 * Mapeamento de features por plano
 * Define quais features estão disponíveis em cada tipo de plano
 */
export const PLAN_FEATURES = {
  'starter': [
    // Features básicas
    // Não inclui features avançadas
  ],
  'professional': [
    FEATURES.STATISTICS,
    FEATURES.FINANCIAL_MANAGEMENT,
    FEATURES.WAITING_LIST,
    FEATURES.WALLET_MANAGEMENT,
    // Outras features do plano Professional
  ],
  'enterprise': [
    FEATURES.STATISTICS,
    FEATURES.ADVANCED_REPORTS,
    FEATURES.UNLIMITED_USERS,
    FEATURES.CUSTOM_BRANDING,
    FEATURES.ADVANCED_AUTOMATION,
    FEATURES.DATA_EXPORT,
    FEATURES.PRIORITY_SUPPORT,
    FEATURES.FINANCIAL_MANAGEMENT,
    FEATURES.MARKETING_TOOLS,
    FEATURES.PATIENT_PORTAL,
    FEATURES.WAITING_LIST,
    FEATURES.WALLET_MANAGEMENT,
    FEATURES.WHATSAPP_COMMUNICATION,
    // Todas as features disponíveis
  ]
};

/**
 * Mapeamento entre features e as operações da API correspondentes
 * Relaciona cada feature com as operações definidas em ApiFeatures.php
 */
export const FEATURE_OPERATIONS = {
  [FEATURES.STATISTICS]: [
    'statistics.read'
  ],
  [FEATURES.ADVANCED_REPORTS]: [
    'reports.read'
  ],
  [FEATURES.FINANCIAL_MANAGEMENT]: [
    'financial.read',
    'financial.create',
    'financial.update',
    'financial.delete'
  ],
  [FEATURES.MARKETING_TOOLS]: [
    'marketing.read',
    'marketing.create',
    'marketing.update',
    'marketing.delete',
    'leads.read',
    'leads.create',
    'leads.update',
    'leads.delete'
  ],
  [FEATURES.WAITING_LIST]: [
    'waiting_list.read',
    'waiting_list.create',
    'waiting_list.update',
    'waiting_list.delete'
  ],
  [FEATURES.WALLET_MANAGEMENT]: [
    'wallet.read',
    'wallet.create',
    'wallet.update',
    'wallet.delete'
  ],
  [FEATURES.DATA_EXPORT]: [
    'company.data_export.read',
    'company.data_export.create'
  ],
  [FEATURES.WHATSAPP_COMMUNICATION] : [
  'whatsapp.messages.read',
  'whatsapp.messages.create',
  'whatsapp.messages.update',
  'whatsapp.messages.delete'
]
};
